import { mirrorEasing } from "./modifiers/mirror.js";
import { reverseEasing } from "./modifiers/reverse.js";
const circIn = (p) => 1 - Math.sin(Math.acos(p));
const circOut = reverseEasing(circIn);
const circInOut = mirrorEasing(circIn);
export {
  circIn,
  circInOut,
  circOut
};
//# sourceMappingURL=circ.js.map
